import './index.less'
import React, { useState } from 'react'

import { Modal } from 'antd'
import JeonbuklogoImage from '../../assets/images/jeonbuk_logo.png'
import pop_close from '@/assets/images/modal/pop-close.svg'

function Footer() {
  const [selectedOption, setSelectedOption] = useState('')
  const [useTerms, setUseTerms] = useState(false)
  const [usePolicy, setUsePolicy] = useState(false)

  const handleSelectChange = (event: { target: { value: any } }) => {
    const selectedValue = event.target.value
    setSelectedOption(selectedValue)

    switch (selectedValue) {
      case 'jeonbuk':
        window.open('https://www.jeonbuk.go.kr/', '_blank')
        break
      case 'lx':
        window.open('https://www.lx.or.kr/', '_blank')
        break
      case 'nolgofarm':
        window.open('https://www.nolgofarm.com//', '_blank')
        break
      default:
        break
    }
  }

  const handleCancel = () => {
    setUseTerms(false)
    setUsePolicy(false)
  }

  const handleUseTerm = () => {
    setUseTerms(true)
  }

  const handleUsePolicy = () => {
    setUsePolicy(true)
  }

  return (
        <div className={'NongDi-Footer'}>
            <div className={'footer'}>
                <div className={'footer-top'}>
                    <ul className={'ftop-list'}>
                        <li className={'ftop-item'}>
                            <a onClick={handleUseTerm}><strong>이용약관</strong></a>
                        </li>
                        <li className={'ftop-item'}>
                            <a onClick={handleUsePolicy}><strong>개인정보처리방침</strong></a>
                        </li>
                    </ul>
                    <select className={'footer-select'} onChange={handleSelectChange} value={selectedOption}>
                        <option value="">{'\u00A0'}관련 사이트</option>
                        <option value="jeonbuk"><a>{'\u00A0'}전라북도청</a></option>
                        <option value="lx"><a>{'\u00A0'}한국국토정보공사</a></option>
                        <option value="nolgofarm"><a>{'\u00A0'}놀고팜</a></option>
                    </select>
                </div>
                <div className={'footer-main'}>
                    <div className={'inner'}>
                        <div>
                          <p className={'address'}>
                              (54968) 전북특별자치도 전주시 완산구 효자로 225 (전북특별자치도청) / 헬프데스크: 063-712-0748,0751
                          </p>
                          <div className={'copyright'}>
                              COPYRIGHT©LX, ALL RIGHTS RESERVED
                          </div>
                        </div>
                        <div className={'logo'}>
                            <img src={JeonbuklogoImage} alt="전라북도 로고" />
                        </div>
                    </div>
                </div>
                <Modal centered
                     closable={false}
                    maskClosable={false}
                    open={useTerms}
                    width={'62rem'}
                    getContainer={false}
                    onCancel={handleCancel}
                    footer={false}>
                    <div className={'modal'}>
                        <div className={'useterms'}>
                            <div className={'popuphead'}>
                                <div className={'title'}>이용약관</div>
                                <img onClick={handleCancel} src={pop_close} />
                            </div>
                            <div className={'popupmain'}>
                                <div className={'innerscroll'}>
                                    <div className={'text'}>
                                        <p>
                                            NONG-DI 농촌 유휴시설 통합플랫폼이 취급하는 모든
                                            개인정보는 개인정보 보호법 등 관련 법령상의 개인정보보호
                                            규정을 준수하여 수집·보유·처리하고 있습니다.
                                        </p>
                                        <br />
                                        <p>
                                            NONG-DI 농촌 유휴시설 통합플랫폼은 개인정보 보호법
                                            제30조에 따라 이용자의 개인정보 보호 및 권익을 보호하고
                                            개인정보와 관련한 이용자의 고충을 원활하게 처리할 수
                                            있도록 다음과 같이 개인정보 처리방침을 두고 있습니다.
                                        </p>
                                        <br />
                                        <p >
                                            개인정보의 처리목적<br />
                                            1. NONG-DI 농촌 유휴시설 통합플랫폼은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고있는 개인정보는 다음의 목적 이외 용도로는 이용되지 않으며,<br />
                                            이용 목적이 변경되는 경우에는 개인정보 보호법 제18조(개인정보의 목적 외 이용·제공제한)에 따라 별도의 동의를 받는 등 필요한 조치를 이행하고 있습니다.<br />
                                            1-1 홈페이지 회원 가입 및 관리 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의<br />
                                            개인정보처리 시 법정 대리인의 동의 여부 확인, 사외보 발송 등을 목적으로 개인정보를 처리합니다.<br />
                                            1-2 민원사무 처리 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등의 목적으로 개인정보를 처리합니다.<br />
                                            2. NONG-DI 농촌 유휴시설 통합플랫폼이 개인정보 보호법 제32조(개인정보파일의 등록 및 공개)에 따라 등록·공개하는 개인정보 파일의 처리 목적은 다음과<br />
                                            같습니다.<br />
                                            2-1 일반회원<br />
                                            운영근거/처리목적<br />
                                            - 정보주체의 동의<br />
                                            - 회원가입자 정보관리<br />
                                            파일에 기록되는 항목<br />
                                            - 필수: 아이디, 비밀번호, 성명, 지도기본위치, 이메일, 휴대전화번호<br />
                                            - 선택: 없음 보유기간: 회원탈퇴 시, 2년<br />
                                            2-2 공공기관 회원<br />
                                            운영근거/처리목적<br />
                                            - 정보주체의 동의<br />
                                            - 회원가입자 정보관리<br />
                                            파일에 기록되는 항목<br />
                                            - 필수: 아이디, 비밀번호, 성명, 지도기본위치, 이메일, 휴대전화번호, 담당업무 및 사용목적<br />
                                            - 선택: 전화번호<br />
                                            보유기간: 회원탈퇴 시, 2년<br />
                                            3. 개인정보의 수집·이용·저장 NONG-DI 농촌 유휴시설 통합플랫폼은 개인정보의 수집 시 개인정보 보호법 제15조 제2항(법령상의무를 준수하기 위하여<br />
                                            불가피한 경우)를 제외 하고는 정보 주체의 동의에 의하여 수집하고 저장은 정부에서 권장하는 암호화를 준수하여 보관하며 개인정보의 동의 목적 내에서만<br />
                                            이용합니다.<br />
                                            <br />
                                            <br />
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal centered
                    closable={false}
                    maskClosable={false}
                    open={usePolicy}
                    width={'62rem'}
                    getContainer={false}
                    onCancel={handleCancel}
                    footer={false}>
                    <div className={'modal'}>
                        <div className={'usePolicy'}>
                            <div className={'popuphead'}>
                                <div className={'title'}>개인정보처리방침</div>
                                <img onClick={handleCancel} src={pop_close} />
                            </div>
                            <div className={'popupmain'}>
                                <div className={'innerscroll'}>
                                    <div className={'text'}>
                                        제1장 총칙
                                        <p >
                                            <br />
                                            제 1 조 (목적)<br />
                                            본 약관은 NONG-DI 농촌 유휴시설
                                            통합플랫폼이 운영하는 웹 사이트
                                            (http://)의 제반 서비스의 이용조건 및
                                            절차에 관한 사항 및 기타 필요한 사항을
                                            규정함을 목적으로 한다.
                                        </p>
                                        <br />
                                        <p >
                                            제 2 조 (용어의 정의)<br />
                                            본 약관에서 사용하는 용어는 다음과 같이 정의한다.
                                        </p>
                                        <br />
                                        <p >
                                            ①회원 : 기본 회원 정보를 입력하였고, 회사와 서비스 이용계약을 체결하여 아이디를 부여받은개인<br />
                                            ②아이디(ID) : 회원식별과 회원의 서비스 이용을 위해 회원이 선정하고 회사가 승인하는 문자와 숫자의 조합<br />
                                            ③비밀번호(Password) : 회원이 통신상의 자신의 비밀을 보호하기 위해 선정한 문자와 숫자의 조합<br />
                                            ④해지 : 회사 또는 회원에 의한 이용계약의 종료<br />
                                        </p>
                                        <p >
                                            <br />
                                            제 3 조 (약관의 공시 및 효력과 변경)
                                            ①본 약관은 회원가입 화면에 게시하여 공시하며 회사는 사정변경 및 영업상 중요한 사유가 있을 경우 약관을 변경할 수 있으며 변경된 약관은 공지사항을 통해 <br />
                                            공시한다<br />
                                            ②본 약관 및 차후 회사사정에 따라 변경된 약관은 이용자에게 공시함으로써 효력을 발생한다.<br />
                                        </p>
                                        <br />
                                        <p >
                                            제 4 조 (약관 외 준칙) <br />
                                            본 약관에 명시되지 않은 사항이 전기통신기본법, 전기통신사업법, 정보통신촉진법, ‘전자상거래등에서의소비자 보호에 관한 법률’, ‘약관의 규제에관한법률’, <br />
                                            ‘전자거래기본법’, ‘전자서명법’, ‘정보통신망 이용촉진등에관한 법률’, ‘소비자보호법’ 등 기타 관계 법령에 규정되어 있을 경우에는 그 규정을 따르도록 한다.
                                        </p>
                                        <br />
                                        <p >
                                            제 2 장 이용계약
                                        </p>
                                        <br />
                                        <p >
                                            제 5 조 (이용신청) <br />
                                            ①이용신청자가 회원가입 안내에서 본 약관과 개인정보보호정책에 동의하고 등록절차(회사의 소정 양식의 가입 신청서 작성)를 거쳐 '확인' 버튼을 누르면 <br />
                                            이용신청을 할 수 있다. <br />
                                            ②이용신청자는 반드시 실명과 실제 정보를 사용해야 하며 1개의 생년월일에 대하여 1건의 이용신청을 할 수 있다. <br />
                                            ③실명이나 실제 정보를 입력하지 않은 이용자는 법적인 보호를 받을 수 없으며, 서비스 이용에 제한을 받을 수 있다. <br />
                                        </p>
                                        <br />
                                        <p >
                                            제 6 조 (이용신청의 승낙)<br />
                                            ①회사는 제5조에 따른 이용신청자에 대하여 제2항 및 제3항의 경우를 예외로 하여 서비스 이용을 승낙한다.<br />
                                            ②회사는 아래 사항에 해당하는 경우에 그 제한사유가 해소될 때까지 승낙을 유보할 수 있다. 가. 서비스 관련 설비에 여유가 없는 경우 나. 기술상 지장이 있는 경우<br />
                                            다. 기타 회사 사정상 필요하다고 인정되는 경우<br />
                                            ③회사는 아래 사항에 해당하는 경우에 승낙을 하지 않을 수 있다.<br />
                                            가. 다른 사람의 명의를 사용하여 신청한 경우<br />
                                            나. 이용자 정보를 허위로 기재하여 신청한 경우<br />
                                            다. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br />
                                            라. 기타 회사가 정한 이용신청 요건이 미비한 경우<br />
                                        </p>
                                        <br />
                                        <p >
                                            제 3 장 계약 당사자의 의무
                                        </p>
                                        <br />
                                        <p >
                                            제 7 조 (회사의 의무)<br />
                                            ①회사는 사이트를 안정적이고 지속적으로 운영할 의무가 있다.<br />
                                            ②회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정될 경우에는 즉시 처리해야 한다. 단, 즉시 처리가 곤란한 경우에는 이용자에게 그 사유와<br />
                                            처리일정을 공지사항 또는 전자우편을 통해 통보해야 한다.<br />
                                            ③제1항의 경우 수사상의 목적으로 관계기관 및 정보통신윤리위원회의 요청이 있거나 영장 제시가 있는 경우, 기타 관계 법령에 의한 경우는 예외로 한다.<br />
                                        </p>
                                        <br />
                                        <p >
                                            제 8 조 (이용자의 의무)<br />
                                            ①이용자는 본 약관 및 회사의 공지사항, 사이트 이용안내 등을 숙지하고 준수해야 하며 기타 회사의 업무에 방해되는 행위를 해서는 안된다.<br />
                                            ②이용자는 회사의 사전 승인 없이 본 사이트를 이용해 어떠한 영리행위도 할 수 없다.<br />
                                            ③이용자는 본 사이트를 통해 얻는 정보를 회사의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 및 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다.<br />
                                        </p>
                                        <br />
                                        <p >
                                            제 4 장 서비스의 제공 및 이용
                                        </p>
                                        <br />
                                        <p >
                                            제 9 조 (서비스 이용)<br />
                                            ①이용자는 본 약관의 규정된 사항을 준수해 사이트를 이용한다.<br />
                                            ②본 약관에 명시되지 않은 서비스 이용에 관한 사항은 회사가 정해 '공지사항'에 게시하거나 또는 별도로 공지하는 내용에 따른다.<br />
                                        </p>
                                        <br />
                                        <p >
                                            제 10 조 (정보의 제공)
                                            회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보에 대하여 전자메일이나 서신우편 등의 방법으로 회원에게 정보를 제공할 수 있다.
                                        </p>
                                        <br />
                                        <p >
                                            제 11 조 (광고게재)<br />
                                            ①회사는 서비스의 운용과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고 등을 게재할 수 있다.<br />
                                            ②회사는 사이트에 게재되어 있는 광고주의 판촉활동에 회원이 참여하거나 교신 또는 거래의 결과로서 발생하는 모든 손실 또는 손해에 대해 책임을 지지 않는다.<br />
                                        </p>
                                        <br />
                                        <p >
                                            제 12 조 (서비스 이용의 제한)<br />
                                            본 사이트 이용 및 행위가 다음 각 항에 해당하는 경우 회사는 해당 이용자의 이용을 제한할 수 있다. <br />
                                            <br />
                                            ①공공질서 및 미풍양속, 기타 사회질서를 해하는 경우 <br />
                                            ②범죄행위를 목적으로 하거나 기타 범죄행위와 관련된다고 객관적으로 인정되는 경우 <br />
                                            ③타인의 명예를 손상시키거나 타인의 서비스 이용을 현저히 저해하는 경우 <br />
                                            ④타인의 의사에 반하는 내용이나 광고성 정보 등을 지속적으로 전송하는 경우 <br />
                                            ⑤해킹 및 컴퓨터 바이러스 유포 등으로 서비스의 건전한 운영을 저해하는 경우 <br />
                                            ⑥다른 이용자 또는 제3자의 지적재산권을 침해하거나 지적재산권자가 지적 재산권의 침해를 주장할 수 있다고 판단되는 경우 <br />
                                            ⑦타인의 아이디 및 비밀번호를 도용한 경우 <br />
                                            ⑧기타 관계 법령에 위배되는 경우 및 회사가 이용자로서 부적당하다고 판단한 경우 <br />
                                        </p>
                                        <br />
                                        제 13 조 (서비스 제공의 중지)<br />
                                        회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부의 제공을 중지할 수 있다.<br />
                                        <br />
                                        ①전기통신사업법 상에 규정된 기간통신 사업자 또는 인터넷 망 사업자가 서비스를 중지했을 경우<br />
                                        ②정전으로 서비스 제공이 불가능할 경우<br />
                                        ③설비의 이전, 보수 또는 공사로 인해 부득이한 경우<br />
                                        ④서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 제공이 어려운 경우<br />
                                        ⑤전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우<br />
                                        <br />
                                        제 14 조 (게시물 관리)<br />
                                        회사는 건전한 통신문화 정착과 효율적인 사이트 운영을 위하여 이용자가 게시하거나 제공하는 자료가 제12조에 해당한다고 판단되는 경우에 임의로 삭제,<br />
                                        자료이동, 등록거부를 할 수 있다.<br />
                                        <br />
                                        제 15 조 (서비스 이용 책임)<br />
                                        이용자는 회사에서 권한 있는 사원이 서명한 명시적인 서면에 구체적으로 허용한 경우를 제외하고는 서비스를 이용하여 불법상품을 판매하는 영업활동을 할 수<br />
                                        없으며 특히 해킹, 돈벌기광고, 음란 사이트를 통한 상업행위, 상용 S/W 불법제공 등을 할 수 없다. 이를 어기고 발생한 영업활동의 결과 및 손실, 관계기관에 의한<br />
                                        구속 등 법적 조치 등에 관해서는 회사가 책임을 지지 않는다. 제 5 장 (재화의 주문 및 결제 관련)<br />
                                        <br />
                                        제16조 (결제방법) <br />
                                        ‘회원’은‘회사’에서판매하는 재화에 대하여 ‘선불카드, 직불카드, 신용카드 등의 각종 카드 결제 수단’을이용하여 결제할 수 있다. 이때 ‘회사’는이용자의 지급방법에 <br />
                                        대하여 재화외어떠한 명목의 수수료를 추가 징수하지 않는다. <br />
                                        <br />
                                        ① ‘회사’는이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 한다. 주문확인에 대한 내용은 해당게시판에서 확인 할 수 있다.<br />
                                        ② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 ‘회사’는배송전에<br />
                                        이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리한다. 다만 이미 대금을 지불한 경우에는 제18조의 ‘반품규정’을따른다.<br />
                                        <br />
                                        제17조 (배송정책) <br />
                                        ① ‘회사’는이용자와 재화의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 결재를 실시한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 <br />
                                        등 기타의 필요한 조치를 취한다. <br />
                                        ②‘회사’는이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 제품을 구매하는 웹 페이지 하단에 명시한다. 만약 ‘회사’가약정 <br />
                                        배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상한다. 하지만 ‘회사’의고의과실이 없음을 입증한 경우에는 그러하지 아니한다. 18조 (취소 및 반품 <br />
                                        환불 규정) ‘회사’는이용자가 구매 신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고 사전에 재화 <br />
                                        등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 한다. <br />
                                        ① 재화가 발송 되기전이용자가 결제를 취소할 경우 ‘회사’는해당 주문건을 취소 처리하고 카드결제 승인을 취소한다. <br />
                                        ② 재화가 발송 된 이후 결제 취소는 불가하다. 단, ‘회사’의부주의 ‘배송’상의문제로 인한 재화의 파손, 변질의 경우 ‘회사’는이용자에게 구매 금액의 반품 및 환불 <br />
                                        조취및 교환 조취를취한다. <br />
                                        <br />
                                        제 6 장 기타<br />
                                        <br />
                                        제 19 조 (면책 및 손해배상) <br />
                                        ①천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 회사의 서비스 제공 책임이 면제된다. <br />
                                        ②회사는 이용자간 또는 이용자와 제3자간의 상호거래 관계에서 발생되는 결과에 대하여 어떠한 책임도 부담하지 않는다. <br />
                                        ③회사는 이용자가 게시판에 게재한 정보, 자료, 내용 등에 관하여 사실의 정확성, 신뢰도 등에 어떠한 책임도 부담하지 않으며 이용자는 본인의 책임 아래 본 <br />
                                        사이트를 이용해야 한다. <br />
                                        ④이용자가 게시 또는 전송한 자료 등에 관하여 손해가 발생하거나 자료의 취사선택, 기타 무료로 제공되는 서비스 이용과 관련해 어떠한 불이익이 발생하더라도 <br />
                                        이에 대한 모든 책임은 이용자에게 있다. <br />
                                        ⑤아이디와 비밀번호의 관리 및 이용자의 부주의로 인하여 발생되는 손해 또는 제3자에 의한 부정사용 등에 대한 책임은 이용자에게 있다. <br />
                                        ⑥이용자가 본 약관의 규정을 위반함으로써 회사에 손해가 발생하는 경우 이 약관을 위반한 이용자는 회사에 발생한 모든 손해를 배상해야 하며 동 손해로부터 <br />
                                        회사를 면책시켜야한다. <br />
                                        <br />
                                        제 20 조 (개인신용정보 제공 및 활용에 대한 동의서)<br />
                                        회사가 회원 가입과 관련해 취득한 개인 신용 정보는 신용정보의 이용 및 보호에 관한 법률 제23조의 규정에 따라 타인에게 제공 및 활용 시 이용자의 동의를<br />
                                        얻어야 한다. 이용자의 동의는 회사가 회원으로 가입한 이용자의 신용정보를 신용정보기관, 신용정보업자 및 기타 이용자 등에게 제공해 이용자의 신용을<br />
                                        판단하기 위한 자료로서 활용하거나 공공기관에서 정책자료로 활용하는데 동의하는 것으로 간주한다.<br />
                                        <br />
                                        제 21 조 (분쟁의 해결)<br />
                                        ①회사와 이용자는 본 사이트 이용과 관련해 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 해야 한다.<br />
                                        ②제1항의 규정에도 불구하고 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 회사의 본사 소재지를 관할하는 법원의 관할로 본다.<br />
                                        <br />
                                        {'<부칙> 본 약관은 2023년 01월 1일부터 적용한다.'}<br />
                                        <br />
                                        <br />
                                        <br /> <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
  )
}

export default Footer
